import { render, staticRenderFns } from "./Bible.vue?vue&type=template&id=67eb0e9e&"
import script from "./Bible.vue?vue&type=script&lang=js&"
export * from "./Bible.vue?vue&type=script&lang=js&"
import style0 from "./Bible.vue?vue&type=style&index=0&id=67eb0e9e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports